import {formatDate} from "@angular/common";
import {getISOWeek, getISOWeekYear, getWeek, getWeekYear, getYear} from 'date-fns';

export class DateUtilsBs {

    private static DEFAULT_LOCALE: string = "de";
    static INST = new DateUtilsBs();

    /**
     * Gets year.
     * @param aDate
     */
    static getYearWeek(aDate: Date): number[] {
        return [this.getYear(aDate), this.getWeek(aDate)];
    }

    /**
     * Gets year.
     * @param aDate
     */
    static getYear(aDate: Date): number {
        return getISOWeekYear(aDate); // date-fns
    }

    /**
     * Gets week
     * @param aDate
     */
    static getWeek(aDate: Date): number {
        return getISOWeek(aDate); // date-fns
    }


    /**
     * TODO convert to date-fns
     * Gets week
     * @param aDate
     */
    static getWeekStartEndDate(y: number, w: number): Date[] {
        // ISO 8601
        var pFirstDayOfYear = new Date(y, 0, 1 + (w - 1) * 7);
        var dow = pFirstDayOfYear.getDay();
        var pStartDate = pFirstDayOfYear;
        if (dow <= 4) {
            pStartDate.setDate(pFirstDayOfYear.getDate() - pFirstDayOfYear.getDay() + 1);
        } else {
            pStartDate.setDate(pFirstDayOfYear.getDate() + 8 - pFirstDayOfYear.getDay());
        }

        let pEndDate = new Date(pStartDate.getTime());
        pEndDate.setDate(pEndDate.getDate() + 6);

        //console.log("Start-End: " + w + "/" + y + " ==> " + pStartDate + " ====> " + pEndDate);

        return [pStartDate, pEndDate];

    }

    /**
     * Formats Date.
     * @param aServiceDay
     */
    static formatDate(aServiceDay: Date, aLocale?: string) {
        return formatDate(aServiceDay, "dd-MM-yyyy", aLocale ? aLocale : DateUtilsBs.DEFAULT_LOCALE);
    }


    /**
     * Formats Date.
     * @param aServiceDay
     */
    static formatDateTime(aServiceDay: Date, aLocale?: string) {
        return formatDate(aServiceDay, "dd-MM-yyyy HH:mm:ss", aLocale ? aLocale : DateUtilsBs.DEFAULT_LOCALE);
    }


    /**
     * Formats Date.
     * @param aServiceDay
     */
    static format(aServiceDay: Date, aPattern: string, aLocale?: string) {
        return formatDate(aServiceDay, aPattern, aLocale ? aLocale : DateUtilsBs.DEFAULT_LOCALE);
    }


    /**
     * Formats Date.
     * @param aServiceDay
     */
    static formatYYYYMMDD(aServiceDay: Date, aLocale?: string) {
        return formatDate(aServiceDay, "yyyy-MM-dd", aLocale ? aLocale : DateUtilsBs.DEFAULT_LOCALE);
    }

    static formatDayName(aDate: Date, aLocale: string) {
        return formatDate(aDate, "EEEE", aLocale ? aLocale : DateUtilsBs.DEFAULT_LOCALE);
    }

    /**
     * Clears.
     * @param aDate
     */
    static clearTime(aDate: Date) {
        let pCloned = new Date(aDate.getTime());
        return this.clearTimeNoClone(pCloned);
    }

    /**
     * Clears.
     * @param aDate
     */
    static clearTimeNoClone(aDate: Date) {
        aDate.setHours(0, 0, 0, 0);
        aDate.setUTCHours(0, 0, 0, 0);
        return aDate;
    }

    static convertToUTC(aDate: Date): Date {
        var now_utc = Date.UTC(aDate.getUTCFullYear(), aDate.getUTCMonth(),
            aDate.getUTCDate(), aDate.getUTCHours(),
            aDate.getUTCMinutes(), aDate.getUTCSeconds());
        let pUTC = new Date(now_utc);
        console.log("Convert to UTC: \n" + pUTC + ",\nISO: " + aDate);
        return pUTC;

    }

    static parseISO8601(aDateStr: string): Date {
        return new Date(aDateStr);
    }

    /**
     * static check.
     * @param aDate
     */
    static isToday(aDate: Date): boolean {
        return this.clearTime(aDate).getTime() == this.clearTimeNoClone(new Date()).getTime();
    }


    /**
     * static check.
     * @param aDate
     */
    static addDays(aDate: Date, aCount: number): Date {
        let pOrig = new Date(aDate);
        let pNew = new Date(pOrig.setDate(pOrig.getDate() + aCount));
        return pNew;
    }


    /**
     * static check.
     * @param aDate
     */
    static isYesterday(aDate: Date): boolean {
        let pToday = new Date();
        return this.clearTime(aDate).getTime() == this.clearTimeNoClone(this.addDays(pToday, -1)).getTime();
    }

    /**
     * Adds week
     * @param aYear
     * @param aWeek
     * @param number
     */
    static addWeek(aYear: number, aWeek: number, aWeekCount: number) : number[] {
        let pWeekStart = this.getWeekStartEndDate(aYear, aWeek)[0];
        let pShifted = this.addDays(pWeekStart, (7*aWeekCount));
        let pShiftedYW = this.getYearWeek(pShifted);
        console.log("SHIFTED KW:" + this.formatYYYYMMDD(pShifted) + ", " + pShiftedYW[0] + "/" + pShiftedYW[1]);
        return pShiftedYW;
    }
}
